import React, {Component} from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Terms from "../../pages/terms/component";
import Privacy from "../../pages/privacy/component";
import Acceptence from "../../pages/acceptence/component";
import {dataRegister} from "../../services/dataRegister";
import Styles from "./style.css";
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";

import PBfaviconAppleTouch from '../../assets/propertybooster-favicon/apple-touch-icon.png';
import PBfavicon16 from '../../assets/propertybooster-favicon/favicon-16x16.png';
import PBfavicon32 from '../../assets/propertybooster-favicon/favicon-32x32.png';
import PBfaviconSiteManifest from '../../assets/propertybooster-favicon/site.webmanifest';
import PBfaviconSiteSafari from '../../assets/propertybooster-favicon/safari-pinned-tab.svg';

import BBfaviconAppleTouch from '../../assets/boostabostad-favicon/apple-touch-icon.png';
import BBfavicon16 from '../../assets/boostabostad-favicon/favicon-16x16.png';
import BBfavicon32 from '../../assets/boostabostad-favicon/favicon-32x32.png';
import BBfaviconSiteManifest from '../../assets/boostabostad-favicon/site.webmanifest';
import BBfaviconSiteSafari from '../../assets/boostabostad-favicon/safari-pinned-tab.svg';

import YLfaviconAppleTouch from '../../assets/yieldlock-favicon/apple-touch-icon.png';
import YLfavicon16 from '../../assets/yieldlock-favicon/favicon-16x16.png';
import YLfavicon32 from '../../assets/yieldlock-favicon/favicon-32x32.png';
import YLfaviconSiteManifest from '../../assets/yieldlock-favicon/site.webmanifest';
import YLfaviconSiteSafari from '../../assets/yieldlock-favicon/safari-pinned-tab.svg';

import ABfaviconAppleTouch from '../../assets/adbop-favicon/apple-touch-icon.png';
import ABfavicon16 from '../../assets/adbop-favicon/favicon-16x16.png';
import ABfavicon32 from '../../assets/adbop-favicon/favicon-32x32.png';
import ABfaviconSiteManifest from '../../assets/adbop-favicon/site.webmanifest';
import ABfaviconSiteSafari from '../../assets/adbop-favicon/safari-pinned-tab.svg';

import SCfaviconAppleTouch from '../../assets/saleschannel-favicon/apple-touch-icon.png';
import SCfavicon16 from '../../assets/saleschannel-favicon/favicon-16x16.png';
import SCfavicon32 from '../../assets/saleschannel-favicon/favicon-32x32.png';
import SCfaviconSiteManifest from '../../assets/saleschannel-favicon/site.webmanifest';
import SCfaviconSiteSafari from '../../assets/saleschannel-favicon/safari-pinned-tab.svg';

import {Helmet} from 'react-helmet';

class RouterWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            no_route: false,
            logo: "",
            name: "",
            email: "",
            domain: "",
            domain_ending: "",
            legal: {}
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        if(this.props.match.params.market){
            if(this.props.match.params.lang !== "sv" && this.props.match.params.lang !== "en"){
                this.props.match.params.lang = "en";
            }
            if(this.props.match.params.option === "terms" || this.props.match.params.option === "privacy" || this.props.match.params.option === "acceptance"){
                if(window.location.hostname !== "localhost"){
                    this._setApiDomain();
                }else{
                    this.setState({isLoading: false, error: false});
                }
            }else{
                this.setState({isLoading: false, no_route: true, error: false});
            }
        }else{
            this.setState({isLoading: false, no_route: true, error: false});
        }
    }

    _setApiDomain(){
        dataRegister.documentLocation().then((response) => {
            let environment = response.headers.get('APP_PRODUCTION');
            if(environment === "true"){
                dataRegister.setApiDomain("primehit");
                this._updateHost(window.location.href);
            }else if(environment === "local"){
                this._updateHost(window.location.href, true);
            }else{
                dataRegister.setApiDomain("devprimehit");
                this._updateHost(window.location.href);
            }
        }, (error) => {
            dataRegister.setApiDomain("devprimehit");
            this._updateHost(window.location.href);
        });
    }

    _updateHost(link, local){
        let url = this._getHostname(link);
        if(url){
            let domain = null;
            let domain_ending = null;
            if(local){
                domain = url.split('.')[1];
                domain_ending = "";
                dataRegister.setApiDomain(domain);
            }else{
                domain = url.split('.')[1];
                domain_ending = url.split('.')[2];
            }
            if(domain && domain_ending && this.props.match.params.saleschannel){
                this.setState({domain: domain, domain_ending: domain_ending}, () => {
                    this._updateData(this.props.match.params.market, this.props.match.params.saleschannel);
                });
            }else{
                this.setState({isLoading: false, error: true});
            }
        }else{
            this.setState({isLoading: false, error: true});
        }
    }

    _updateData(market, channel){
        dataRegister.logo(market, channel).then((response) => {
            if(response.logo && response.name){
                this.setState({logo: response.logo, isLoading: false, company_name: response.name, name: this.props.match.params.saleschannel, email: response.from_email, legal: response.legal_counter_part, error: false});
            }else{
                this.setState({isLoading: false, error: true});
            }
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _getHostname(url){
        var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        }
        else {
            return null;
        }
    }

    renderLoader(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return '#33B8CF'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return '#7ECF5B'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return '#00273A'
            }else{
                return '#41CBC7'
            }
        }catch (e) {
            return '#ffffff'
        }
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad(){
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        }catch (e) {
            return false
        }
    }

    renderAdbop(){
        try {
            return window.location.hostname.indexOf("adbop") !== -1
        }catch (e) {
            return false
        }
    }

    renderSaleschannel(){
        try {
            return window.location.hostname.indexOf("saleschannel") !== -1
        }catch (e) {
            return false
        }
    }

    _renderText(item) {
        return langRegister.get("router-wrapper", item, "en");
    }

    render() {
        return (
            <div>
                {
                    this.renderPropertyBooster() &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={PBfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={PBfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={PBfavicon16}/>
                        <link rel="manifest" href={PBfaviconSiteManifest}/>
                        <link rel="mask-icon" href={PBfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#33b8cf"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                    </Helmet>
                }
                {
                    this.renderBoostaBostad() &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={BBfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={BBfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={BBfavicon16}/>
                        <link rel="manifest" href={BBfaviconSiteManifest}/>
                        <link rel="mask-icon" href={BBfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#7ecf5b"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                    </Helmet>
                }
                {
                    this.renderYieldlock() &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={YLfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={YLfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={YLfavicon16}/>
                        <link rel="manifest" href={YLfaviconSiteManifest}/>
                        <link rel="mask-icon" href={YLfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#e65032"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                    </Helmet>
                }
                {
                    this.renderAdbop() &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={ABfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={ABfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={ABfavicon16}/>
                        <link rel="manifest" href={ABfaviconSiteManifest}/>
                        <link rel="mask-icon" href={ABfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#41CBC7"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                    </Helmet>
                }
                {
                    this.renderSaleschannel() &&
                    <Helmet>
                        <link rel="apple-touch-icon" sizes="180x180" href={SCfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={SCfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={SCfavicon16}/>
                        <link rel="manifest" href={SCfaviconSiteManifest}/>
                        <link rel="mask-icon" href={SCfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#41CBC7"/>
                        <meta name="theme-color" content="#FFFFFF"/>
                    </Helmet>
                }
                {
                    !this.state.isLoading && !this.state.error && !this.state.no_route &&
                    <div className={Styles.container}>
                        <img className={Styles.logo} src={this.state.logo}/>
                        {
                            this.props.match.params.option === "terms" &&
                            <Terms props={this.props} market={this.props.match.params.market} lang={this.props.match.params.lang} name={this.state.name} domain_ending={this.state.domain_ending} domain={this.state.domain} legal={this.state.legal}/>
                        }
                        {
                            this.props.match.params.option === "privacy" &&
                            <Privacy props={this.props} market={this.props.match.params.market} lang={this.props.match.params.lang} name={this.state.name} domain_ending={this.state.domain_ending} domain={this.state.domain} legal={this.state.legal}/>
                        }
                        {
                            this.props.match.params.option === "acceptance" &&
                            <Acceptence props={this.props} market={this.props.match.params.market} lang={this.props.match.params.lang} name={this.state.name} domain_ending={this.state.domain_ending} domain={this.state.domain} legal={this.state.legal}/>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={this.renderLoader()} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error && !this.state.no_route &&
                    <div className={Styles.loader}>
                        <div className={Styles.error}>
                            {this._renderText("item_1")}
                        </div>
                    </div>
                }
                {
                    !this.state.isLoading && !this.state.error && this.state.no_route &&
                    <div className={Styles.loader}>
                        <div className={Styles.error}>
                            {this._renderText("item_2")}
                        </div>
                    </div>
                }
            </div>
        )
    }

}

export default RouterWrapper


// WEBPACK FOOTER //
// ./src/components/router-wrapper/component.js